import { Component, OnInit } from '@angular/core';
import { SharedService } from 'src/app/services/shared.service';
import { Router } from '@angular/router';
import { Global } from 'asap-crud';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

    public currentUserName: string = '';
    public isLoggedOut: boolean = false;
    public currentLanguage: string = 'pt-br';
    public accountsList: any[] = [];
    public selectedAccountId: any = '';
    public loadingAccounts: boolean = false;
    public isSwitchingAccount: boolean = false;
    public showAccountSelector: boolean = false;

    constructor(
        public service: SharedService,
        public router: Router,
        public global: Global,
        public authService: AuthService,
        public userService: UserService,
        public translate: TranslateService,
        public http: HttpClient
    ) {}

    ngOnInit() {
        const savedLang = localStorage.getItem('asap_selected_language') || sessionStorage.getItem('language') || 'pt-br';
        this.currentLanguage = savedLang;
        try {
            this.translate.setDefaultLang(savedLang);
            this.translate.use(savedLang);
        } catch (e) {}

        if (sessionStorage.getItem('asap_session_terminated') === 'true') {
            this.isLoggedOut = true;
            this.lockNavigation();
            return;
        }

        this.fetchUserName();
        this.loadLinkedAccounts();
    }

    public getAuthenticatedClientId(): string {
        const loggedUserRaw = sessionStorage.getItem('loggedUser') || localStorage.getItem('loggedUser');
        if (loggedUserRaw) {
            try {
                const parsed = JSON.parse(loggedUserRaw);
                if (parsed && parsed.data && parsed.data.client_id !== undefined && parsed.data.client_id !== null) {
                    return String(parsed.data.client_id);
                }
            } catch (e) {}
        }
        return localStorage.getItem('client') || sessionStorage.getItem('client') || '20';
    }

    public loadLinkedAccounts() {
        this.loadingAccounts = true;
        const currentClient = this.getAuthenticatedClientId();
        this.selectedAccountId = '';

        const isSwitchParam = (window.location && window.location.search && (window.location.search.indexOf('switch=true') >= 0 || window.location.search.indexOf('switch=1') >= 0)) ||
                              (this.authService && this.authService.params && (this.authService.params.switch === 'true' || this.authService.params.switch === '1'));

        const alreadyAllowed = isSwitchParam ||
                               sessionStorage.getItem('asap_can_switch_accounts') === 'true' || 
                               localStorage.getItem('asap_can_switch_accounts') === 'true';
        if (alreadyAllowed) {
            this.showAccountSelector = true;
            sessionStorage.setItem('asap_can_switch_accounts', 'true');
            localStorage.setItem('asap_can_switch_accounts', 'true');
        }

        if (this.authService && typeof this.authService.getLinkedAccounts === 'function') {
            this.authService.getLinkedAccounts(currentClient).subscribe(
                (res: any) => {
                    this.loadingAccounts = false;
                    this.handleAccountsResponse(res, currentClient);
                },
                (err: any) => {
                    this.fallbackLoadLinkedAccounts(currentClient, currentClient);
                }
            );
        } else {
            this.fallbackLoadLinkedAccounts(currentClient, currentClient);
        }
    }

    private handleAccountsResponse(res: any, currentClient: string) {
        let list: any[] = [];
        if (res && res.data && Array.isArray(res.data)) {
            list = res.data;
        } else if (Array.isArray(res)) {
            list = res;
        }

        if (list.length > 0) {
            this.accountsList = list;
            const indexZeroId = (list[0] && list[0].id !== undefined && list[0].id !== null) ? String(list[0].id) : null;

            const isSwitchParam = (window.location && window.location.search && (window.location.search.indexOf('switch=true') >= 0 || window.location.search.indexOf('switch=1') >= 0)) ||
                                  (this.authService && this.authService.params && (this.authService.params.switch === 'true' || this.authService.params.switch === '1'));

            const alreadyAllowed = isSwitchParam ||
                                   sessionStorage.getItem('asap_can_switch_accounts') === 'true' || 
                                   localStorage.getItem('asap_can_switch_accounts') === 'true';

            if (alreadyAllowed) {
                sessionStorage.setItem('asap_can_switch_accounts', 'true');
                localStorage.setItem('asap_can_switch_accounts', 'true');
                this.showAccountSelector = true;
            } else {
                // Primeiro acesso: verifica se o client_id do usuário logado é igual ao id no índice 0 da API
                if (indexZeroId && currentClient && String(currentClient) === String(indexZeroId)) {
                    // É igual: guarda em memória essa informação e o select continua disponível mesmo se mudar de conta
                    sessionStorage.setItem('asap_can_switch_accounts', 'true');
                    localStorage.setItem('asap_can_switch_accounts', 'true');
                    localStorage.setItem('asap_master_client_id', indexZeroId);
                    this.showAccountSelector = true;
                } else {
                    // É diferente: o select fica oculto para o usuário
                    sessionStorage.setItem('asap_can_switch_accounts', 'false');
                    localStorage.setItem('asap_can_switch_accounts', 'false');
                    this.showAccountSelector = false;
                }
            }

            this.selectedAccountId = '';
        } else {
            this.showAccountSelector = false;
        }
    }

    private fallbackLoadLinkedAccounts(clientId: number | string = 20, currentClient: string = '') {
        try {
            const apiURL = localStorage.getItem('apiURL') || 'https://api.tecnologiaasap.com.br';
            const token = sessionStorage.getItem('token') || '';
            let headers = new HttpHeaders();
            if (token) {
                headers = headers.set('Authorization', token);
            }
            const url = `${apiURL}/api/v2/admin/asap-client/vinculo/${clientId}?client_id=${clientId}`;
            this.http.get(url, { headers }).subscribe(
                (res: any) => {
                    this.loadingAccounts = false;
                    this.handleAccountsResponse(res, currentClient);
                },
                (err: any) => {
                    this.loadingAccounts = false;
                    console.error('Erro ao carregar contas vinculadas via HTTP fallback:', err);
                }
            );
        } catch (e) {
            this.loadingAccounts = false;
            console.error('Erro no fallbackLoadLinkedAccounts:', e);
        }
    }

    public onAccountChange(newAccountId: any) {
        if (!newAccountId) return;
        this.isSwitchingAccount = true;
        this.selectedAccountId = newAccountId;

        sessionStorage.setItem('asap_is_account_switching', 'true');
        localStorage.setItem('asap_is_account_switching', 'true');
        sessionStorage.setItem('asap_can_switch_accounts', 'true');
        localStorage.setItem('asap_can_switch_accounts', 'true');

        const currentClientId = localStorage.getItem('client') || sessionStorage.getItem('client') || '20';

        if (this.authService && typeof this.authService.switchAccount === 'function') {
            this.authService.switchAccount(newAccountId, currentClientId).subscribe(
                (res: any) => this.handleSwitchSuccess(res, newAccountId),
                (err: any) => this.fallbackSwitchAccount(newAccountId, currentClientId)
            );
        } else {
            this.fallbackSwitchAccount(newAccountId, currentClientId);
        }
    }

    private fallbackSwitchAccount(newAccountId: any, currentClientId: any) {
        try {
            const apiURL = localStorage.getItem('apiURL') || 'https://api.tecnologiaasap.com.br';
            const token = sessionStorage.getItem('token') || '';
            let headers = new HttpHeaders();
            if (token) {
                headers = headers.set('Authorization', token);
            }
            const switchUrl = `${apiURL}/api/switch/${newAccountId}?client_id=${currentClientId}`;
            this.http.get(switchUrl, { headers }).subscribe(
                (res: any) => this.handleSwitchSuccess(res, newAccountId),
                (err: any) => {
                    this.isSwitchingAccount = false;
                    console.error('Erro ao executar switch de conta via HTTP fallback:', err);
                    localStorage.setItem('client', String(newAccountId));
                    sessionStorage.setItem('client', String(newAccountId));
                    setTimeout(() => {
                        window.location.reload();
                    }, 100);
                }
            );
        } catch (e) {
            this.isSwitchingAccount = false;
            console.error('Erro no fallbackSwitchAccount:', e);
            localStorage.setItem('client', String(newAccountId));
            sessionStorage.setItem('client', String(newAccountId));
            setTimeout(() => {
                window.location.reload();
            }, 100);
        }
    }

    private handleSwitchSuccess(res: any, newAccountId: any) {
        this.isSwitchingAccount = false;
        let newToken: string | null = null;
        if (res && res.token) {
            newToken = res.token;
        } else if (res && res.data && res.data.token) {
            newToken = res.data.token;
        }

        sessionStorage.setItem('asap_can_switch_accounts', 'true');
        localStorage.setItem('asap_can_switch_accounts', 'true');
        sessionStorage.setItem('asap_is_account_switching', 'true');
        localStorage.setItem('asap_is_account_switching', 'true');
        localStorage.setItem('asap_master_client_id', '20');

        if (newToken) {
            const origin = window.location.origin;
            window.location.href = `${origin}/?token=${encodeURIComponent(newToken)}&switch=true`;
        } else {
            localStorage.setItem('client', String(newAccountId));
            sessionStorage.setItem('client', String(newAccountId));
            setTimeout(() => {
                window.location.reload();
            }, 100);
        }
    }

    public onLanguageChange(lang: string) {
        if (!lang) return;
        this.currentLanguage = lang;
        try {
            localStorage.setItem('asap_selected_language', lang);
            sessionStorage.setItem('language', lang);
            this.translate.use(lang);
            setTimeout(() => {
                window.location.reload();
            }, 100);
        } catch (e) {
            window.location.reload();
        }
    }

    public fetchUserName() {
        let userId = null;
        try {
            if (this.global && this.global.loggedUser) {
                const u = this.global.loggedUser();
                if (u) {
                    if (u.name || u.nome || u.user_name) {
                        this.currentUserName = (u.name || u.nome || u.user_name).trim();
                        return;
                    }
                    if (u.id) {
                        userId = u.id;
                    }
                }
            }
        } catch (e) {}

        const storageData = this.extractFromStorage();
        if (storageData.name) {
            this.currentUserName = storageData.name;
            return;
        }
        if (!userId && storageData.id) {
            userId = storageData.id;
        }

        if (userId && this.userService && this.userService.profile) {
            try {
                this.userService.profile(userId).subscribe(
                    (res: any) => {
                        const name = res && res.data ? (res.data.name || res.data.nome || res.data.user_name) : null;
                        if (name && typeof name === 'string' && name.trim()) {
                            this.currentUserName = name.trim();
                        }
                    },
                    err => {}
                );
            } catch (e) {}
        }

        try {
            if (this.authService && this.authService.getUserLogged) {
                this.authService.getUserLogged().subscribe(
                    (res: any) => {
                        let name = '';
                        if (res && res.data) {
                            name = res.data.name || res.data.nome || res.data.user_name || '';
                            if (res.data.certificate) {
                                sessionStorage.setItem('asap_certificate_base', String(res.data.certificate).trim());
                                localStorage.setItem('asap_certificate_base', String(res.data.certificate).trim());
                            }
                        } else if (res) {
                            name = res.name || res.nome || res.user_name || '';
                        }
                        if (name && name.trim()) {
                            this.currentUserName = name.trim();
                        }
                    },
                    err => {}
                );
            }
        } catch (e) {}
    }

    private extractFromStorage(): { name: string; id: any } {
        const result = { name: '', id: null };
        const storages = [sessionStorage, localStorage];

        for (const storage of storages) {
            if (!storage) continue;
            for (let i = 0; i < storage.length; i++) {
                const key = storage.key(i);
                if (!key) continue;
                try {
                    const raw = storage.getItem(key);
                    if (!raw) continue;

                    if (raw.startsWith('{') || raw.startsWith('[')) {
                        const obj = JSON.parse(raw);
                        const candidates = [
                            obj.data,
                            obj.user,
                            obj,
                            obj.data && obj.data.user,
                            obj.response && obj.response.data
                        ];
                        for (const c of candidates) {
                            if (c && typeof c === 'object') {
                                if (!result.id && (c.id || c.user_id)) {
                                    result.id = c.id || c.user_id;
                                }
                                const name = c.name || c.nome || c.user_name || (c.value && (c.value.name || c.value.nome));
                                if (name && typeof name === 'string' && name.trim() && name.trim().toLowerCase() !== 'gestor' && name.trim() !== 'null') {
                                    result.name = name.trim();
                                    return result;
                                }
                            }
                        }
                    }
                } catch (e) {}
            }
        }

        return result;
    }

    public get userName(): string {
        if (this.currentUserName && this.currentUserName.trim()) {
            return this.currentUserName;
        }
        const fromStorage = this.extractFromStorage();
        if (fromStorage.name) {
            this.currentUserName = fromStorage.name;
            return fromStorage.name;
        }
        return 'Gestor';
    }

    public get pageTitle(): string {
        const url = (this.router && this.router.url) ? this.router.url : (window.location ? window.location.pathname : '');
        if (url.includes('/analytics-news')) {
            return 'Analytics';
        }
        if (url.includes('/courses-news')) {
            return 'Cursos';
        }
        if (url.includes('/fast-courses-news')) {
            return 'Aulas Rápidas';
        }
        if (url.includes('/required-courses-news')) {
            return 'Cursos Obrigatórios/Essenciais';
        }
        if (url.includes('/journeys-news')) {
            return 'Jornadas';
        }
        if (url.includes('/engagement-evolution-news')) {
            return 'Evolução de Engajamento';
        }
        return this.service.moduleTitle() || 'Analytics';
    }

    public doExit() {
        try {
            sessionStorage.removeItem('token');
            sessionStorage.removeItem('loggedUser');
            sessionStorage.removeItem('client');
            sessionStorage.removeItem('user');
            sessionStorage.removeItem('asap_can_switch_accounts');
            sessionStorage.removeItem('asap_is_account_switching');
            sessionStorage.removeItem('asap_master_client_id');
            localStorage.removeItem('token');
            localStorage.removeItem('loggedUser');
            localStorage.removeItem('client');
            localStorage.removeItem('user');
            localStorage.removeItem('asap_can_switch_accounts');
            localStorage.removeItem('asap_is_account_switching');
            localStorage.removeItem('asap_master_client_id');
            sessionStorage.setItem('asap_session_terminated', 'true');
        } catch (e) {}

        this.isLoggedOut = true;
        this.lockNavigation();

        try {
            window.close();
        } catch (e) {}

        try {
            window.open('', '_self', '');
            window.close();
        } catch (e) {}

        try {
            self.close();
        } catch (e) {}
    }

    public lockNavigation() {
        try {
            history.pushState(null, '', window.location.href);
            window.onpopstate = () => {
                history.pushState(null, '', window.location.href);
            };
        } catch (e) {}
    }

    public forceCloseTab() {
        try {
            window.close();
        } catch (e) {}
        try {
            window.open('', '_self', '');
            window.close();
        } catch (e) {}
        try {
            self.close();
        } catch (e) {}
    }

}
